import { instanceOf } from 'prop-types';
import { DaypickerCaptionWrapper, DaypickerCaption, DaypickerCaptionMonth, DaypickerCaptionYear } from './Styled';
import { MONTHS } from '../utils';
const preparedMonths = months => months.slice(1);
const Caption = ({
  date
}) => {
  const months = preparedMonths(MONTHS);
  const month = date.getMonth();
  const year = date.getFullYear();
  return /*#__PURE__*/React.createElement(DaypickerCaptionWrapper, null, /*#__PURE__*/React.createElement(DaypickerCaption, null, /*#__PURE__*/React.createElement(DaypickerCaptionMonth, null, months[month]), /*#__PURE__*/React.createElement(DaypickerCaptionYear, null, year)));
};
Caption.propTypes = {
  date: instanceOf(Date)
};
export default Caption;